export enum DataSourcesCategoriesEnum {
  TABLE = 'table',
  QUERY = 'query',
}
